import React, { useEffect } from "react";
import { MobileModalStyles as styles } from "../css/styles";

interface MobileModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  header: string;
}

const MobileModal: React.FC<MobileModalProps> = ({ isOpen, onClose, children, header }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden"; 
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto"; 
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
            <h1>{header}</h1>
            <button className={styles.closeButton} onClick={onClose}>✖</button>
        </div>
        <div className={styles.content}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default MobileModal;